import type { FullMode } from '../domain/Mode'

export function formatMode(mode: FullMode) {
  switch (mode) {
    case 'drayage':
      return 'DRAY'
    case 'full_truck_load':
      return 'FTL'
    case 'less_than_truckload':
      return 'LTL'
    case 'partial_truckload':
      return 'PTL'
    case 'intermodal':
      return 'IMDL'
    case 'EXP':
      return 'EXP'
    case 'OCEAN':
      return 'OCEAN'
    case 'RAIL':
      return 'RAIL'
    default:
      return 'N/A'
  }
}
